<div class="invoicing-list mt-4">
  <div class="clearfix">
    <h5 class="float-start mb-0">Facturen</h5>
    <button type="button" class="btn btn-sm btn-link float-end p-0" (click)="toInvoicing()">
      {{'ui.go-to'|translate }} {{'ui.the'|translate|lowercase}} {{'entity.invoices'|translate}}
      <i class="fa fa-arrow-right"></i>
    </button>
  </div>
  <ul ngbNav [(activeId)]="activeTabId" class="nav nav-tabs mt-2">
    <li *ngFor="let tab of tabs" [ngbNavItem]="tab.id">
      <a ngbNavLink class="me-4" [ngClass]="tab.className" [class.active]="activeTabId === tab.id" (click)="selectTab(tab.id)">
        <span *ngIf="tab.stateId !== null" class="status-indicator me-2" [ngClass]="tab.className"></span>
        <span>
          {{tab.label}}<ng-container *ngIf="tab.stateId !== null"> ({{getInvoiceCount(tab.stateId)}})</ng-container>
        </span>
      </a>
    </li>
  </ul>
  <div class="invoice-tab-content">
    <div *ngIf="visibleInvoices.length; else noInvoices" class="table-responsive">
      <table class="table table-sm table-borderless mb-0">
        <thead>
          <tr>
            <td class="status-column ps-0"></td>
            <td>{{'invoice.number'|translate}}<br />{{'invoice.date'|translate}}</td>
            <td>{{'entity.project'|translate}} / {{'entity.customer'|translate}}</td>
            <td class="text-right">{{'ui.totalprice'|translate}}</td>
            <td class="text-right">{{'entity.outstanding'|translate}}</td>
            <td>{{'entity.due-date'|translate}}</td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of visibleInvoices; trackBy: trackByInvoiceId"
            class="invoice-row" tabindex="0"
            (click)="openInvoice(item.invoice.id)"
            (keydown.enter)="openInvoice(item.invoice.id)">
            <td class="status-column ps-0">
              <span
                class="status-indicator status-bar"
                [ngClass]="getStatusClass(item.status.id)"
                [ngbTooltip]="getStatusLabel(item)">
              </span>
            </td>
            <td>
              <jbm-link-button
                class="invoice-number"
                [caption]="item.invoice.number"
                [showIcon]="false"
                [tooltip]="('entity.invoice'|translate) + ' ' + ('ui.open'|translate|lowercase)"
                (click)="$event.stopPropagation()"
                (onClick)="openInvoice(item.invoice.id)">
              </jbm-link-button>
              <div>{{item.invoice.date}}</div>
            </td>
            <td>
              <jbm-link-button
                [caption]="item.project.name"
                [showIcon]="false"
                (click)="$event.stopPropagation()"
                (onClick)="showProject(item.project.id)">
              </jbm-link-button>
              <div>{{item.customer.name}}</div>
            </td>
            <td class="amount-column text-right">{{item.invoice.totalPrice | money}}</td>
            <td class="amount-column text-right">{{item.invoice.outstanding | money}}</td>
            <td class="date-column">{{item.invoice.dueDate}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #noInvoices>
      <jbm-empty-view [emptyView]="true"></jbm-empty-view>
    </ng-template>
  </div>
</div>
